import { render, staticRenderFns } from "./ktdwzjDetail.vue?vue&type=template&id=12081d5c&scoped=true"
import script from "./ktdwzjDetail.vue?vue&type=script&lang=js"
export * from "./ktdwzjDetail.vue?vue&type=script&lang=js"
import style0 from "./ktdwzjDetail.vue?vue&type=style&index=0&id=12081d5c&prod&lang=css"
import style1 from "./ktdwzjDetail.vue?vue&type=style&index=1&id=12081d5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12081d5c",
  null
  
)

export default component.exports